import { z } from "zod";

export const getVehiclesByDepartmentPayloadSchema = z.object({
  departmentUuid: z.uuid(),
});

export type GetVehiclesByDepartmentPayload = z.infer<
  typeof getVehiclesByDepartmentPayloadSchema
>;
